import { features } from "../data/features";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 }
};

export function Features() {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Everything You Need to Succeed on Pinterest
          </h2>
          <p className="mt-4 text-lg leading-8 text-gray-600">
            Powerful AI-driven tools to automate your Pinterest marketing and drive more traffic to your Shopify store.
          </p>
        </motion.div>

        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid lg:grid-cols-3 gap-8 lg:gap-12"
        >
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              variants={item}
              className="relative group"
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-red-50 to-red-100/50 transform transition duration-300 group-hover:-translate-y-1" />
              <div className="relative p-8">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-red-600/10 text-red-600 mb-6">
                  <img src={feature.illustration} alt={feature.title} className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

function FeatureCard({ illustration, title, description }: typeof features[0]) {
  return (
    <div className="relative bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow group overflow-hidden">
      <div className="absolute -right-8 -top-8 w-24 h-24 bg-gradient-to-br from-blue-100 to-transparent rounded-full opacity-60 group-hover:scale-110 transition-transform" />
      
      <div className="relative">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-blue-50 text-blue-600 mb-4 group-hover:-translate-y-1 transition-transform">
          <img src={illustration} alt={title} className="w-6 h-6" />
        </div>
      </div>

      <div className="relative">
        <h3 className="text-base sm:text-lg font-medium mb-2 text-gray-900">{title}</h3>
        <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500/10 to-transparent group-hover:opacity-100 opacity-0 transition-opacity" />
    </div>
  );
} 